"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = void 0;

/* eslint-disable import/prefer-default-export */
var formatNumber = function (value, places, decimal, thousands) {
  if (places === void 0) {
    places = 0;
  }

  if (decimal === void 0) {
    decimal = '.';
  }

  if (thousands === void 0) {
    thousands = ',';
  }

  var result = '';
  var str = value.toString();
  str = str.replace(/^-/, '');
  var split = str.split('.');
  var integer = split[0];
  var fraction = split[1];

  if (/e/.test(str)) {
    result = str;
  } else {
    for (var i = integer.length; i > 0; i -= 3) {
      if (i < integer.length) {
        result = thousands + result;
      }

      result = integer.slice(Math.max(0, i - 3), i) + result;
    }
  }

  if (fraction) {
    var count = places - fraction.length;
    var zeros = count > 0 ? '0'.repeat(places - fraction.length) : '';
    result += decimal + ("" + zeros + fraction).substr(0, places);
  }

  return (value < 0 ? '-' : '') + result;
};

exports.formatNumber = formatNumber;